import {Validators} from '@angular/forms';

import {AutocompleteControl, Helper} from 'appShared/classes';
import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums/common';
import {BaseControl, RadioGroupControl} from 'appShared/classes/controls';

import {MessagingStatusesEnum} from '@spa/api';

import {InArrayValidator, WhitespaceValidator} from '@spa/validators';

import {
    EmailTemplateFieldNameFooter,
    EmailTemplateFieldNameHeader,
    EmailTemplateFieldNameSignature,
    EmailTemplateFooterSelector,
    EmailTemplateHeaderSelector,
    EmailTemplateSignatureSelector,
    MessageTemplateCustomerProductIdSelector,
    MessageTemplateCustomerSelector,
    MessageTemplateFieldCustomerProduct,
    MessageTemplateFieldNameCompany,
    MessageTemplateFieldNameStatus,
    MessageTemplateFieldNameTemplateName,
    MessageTemplateStatusSelector,
    MessageTemplateTemplateNameSelector
} from 'appAssets/selectors';

export interface EmailTemplatesControlsInterface {
    status: RadioGroupControl;
    company: AutocompleteControl;
    customerProduct: AutocompleteControl;
    name: BaseControl;
    footer: BaseControl;
    header: BaseControl;
    signature: BaseControl;
}

function prepareStatusOptions(isCreate: boolean, hasApprovePermission: boolean) {
    const options = [
        {
            label: Helper.textsHelper().getMessagingStatusName(MessagingStatusesEnum.PendingApproval),
            value: MessagingStatusesEnum.PendingApproval,
            color: ColorCodesEnum.Primary,
        },
    ];

    if (hasApprovePermission) {
        options.push(
            {
                label: Helper.textsHelper().getMessagingStatusName(MessagingStatusesEnum.Approved),
                value: MessagingStatusesEnum.Approved,
                color: ColorCodesEnum.Primary,
            }
        );
    }

    if (!isCreate && hasApprovePermission) {
        options.push(
            {
                label: Helper.textsHelper().getMessagingStatusName(MessagingStatusesEnum.Rejected),
                value: MessagingStatusesEnum.Rejected,
                color: ColorCodesEnum.Primary,
            },
        );
    }

    return options;
}

export const EmailTemplatesControls = (isCreate = true, hasApprovePermission: boolean): EmailTemplatesControlsInterface => {
    return {
        status: new RadioGroupControl({
            name: MessageTemplateStatusSelector,
            value: null,
            placeholder: MessageTemplateFieldNameStatus,
            validators: [Validators.required, InArrayValidator([
                MessagingStatusesEnum.PendingApproval,
                MessagingStatusesEnum.Approved,
                MessagingStatusesEnum.Rejected,
            ])],
            componentType: ComponentTypesEnum.RadioGroup,
            options: prepareStatusOptions(isCreate, hasApprovePermission),
            sortIndex: 1,
            floatingLabelNever: true
        }),
        company: new AutocompleteControl({
            name: MessageTemplateCustomerSelector,
            value: null,
            placeholder: MessageTemplateFieldNameCompany,
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: [],
        }),
        customerProduct: new AutocompleteControl({
            name: MessageTemplateCustomerProductIdSelector,
            value: null,
            placeholder: MessageTemplateFieldCustomerProduct,
            validators: [],
            componentType: ComponentTypesEnum.Autocomplete,
            options: [],
        }),
        name: new BaseControl({
            name: MessageTemplateTemplateNameSelector,
            value: null,
            placeholder: MessageTemplateFieldNameTemplateName,
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Text,
            sortIndex: 2,
            floatingLabelNever: true,
        }),
        footer: new BaseControl({
            name: EmailTemplateFooterSelector,
            value: null,
            placeholder: EmailTemplateFieldNameFooter,
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Textarea,
            sortIndex: 5,
            floatingLabelNever: true
        }),
        header: new BaseControl({
            name: EmailTemplateHeaderSelector,
            value: null,
            placeholder: EmailTemplateFieldNameHeader,
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Textarea,
            sortIndex: 6,
            floatingLabelNever: true
        }),
        signature: new BaseControl({
            name: EmailTemplateSignatureSelector,
            value: null,
            placeholder: EmailTemplateFieldNameSignature,
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Textarea,
            sortIndex: 7,
            floatingLabelNever: true
        }),
    };
};
